module.exports = __webpack_public_path__ + "static/media/bulb-laboratories1.321ee3b7.png";